export function ReplaceIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M7 6a1 1 0 100 2h7a4.002 4.002 0 013.874 3h-1.251c-.531 0-.818.664-.472 1.094l2 2.49a1.074 1.074 0 001.698 0l2-2.49c.346-.43.06-1.094-.472-1.094h-1.46A6.002 6.002 0 0014 6H7zM18 17a1 1 0 01-1 1h-7a6.002 6.002 0 01-5.917-5h-1.46c-.531 0-.818-.664-.472-1.094l2-2.49a1.074 1.074 0 011.698 0l2 2.49c.346.43.06 1.094-.472 1.094H6.126c.444 1.725 2.01 3 3.874 3h7a1 1 0 011 1z"
      ></path>
    </svg>
  );
}
